import request from '../../../../../services/axios';
import {
  CashBackSource,
  CashBackStatus,
} from '../getCashBackCards/cashBackCards.types';

export interface ICashBackDetails {
  activated_at: string;
  amount: number;
  description: string;
  expires_at: string;
  guid: string;
  reserved_amount: number;
  source: CashBackSource;
  status: CashBackStatus;
  used_amount: number;
  withdrawal_available_at: string;
}

export const getCashBackCardDetail = async (cashBackGuid: string) => {
  const {data}: {data: ICashBackDetails} = await request.get(
    `/api/v2/payment/cashback/cards/${cashBackGuid}`,
  );

  return data;
};
